import React, { useEffect, useState } from 'react';
import '../../css/BdIndex.css';
import { API_BASE_URL } from '../scripts/control';

const BdIndex = () => {
    const [sliders, setSliders] = useState([]);

    useEffect(() => {
        fetch(`${API_BASE_URL}/api/bdhome_func.php`)
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    console.error("Error al obtener las últimas actualizaciones:", data.error);
                } else {
                    setSliders(data);
                }
            })
            .catch(error => console.error("Error en la solicitud:", error));
    }, []);

    return (
        <div className="bd">
        <div className="container">
            {/* Logo */}
            <div className="row">
                <div className="logo-container">
                    <div className="logo-content d-flex justify-content-center flex-wrap">
                        <span className="logo-letter" id="bdlogo-L">L</span>
                        <span className="logo-letter" id="bdlogo-I">I</span>
                        <span className="logo-letter" id="bdlogo-B">B</span>
                        <span className="logo-letter" id="bdlogo-D">D</span>
                        <span className="logo-letter" id="bdlogo-C">C</span>
                        <span className="logo-letter" id="bdlogo-O">O</span>
                        <span className="logo-letter" id="bdlogo-M">M</span>
                        <span className="bdlogo-balloon">
                            <img src={`${API_BASE_URL}/public/uploads/images/comic.png`}/>
                        </span>
                    </div>
                </div>
                <div className="logotext text-center">
                    <p className="logo-text">Base de Datos y Etiquetas <br /> Para la Investigación de Contenidos Audiovisuales</p>
                </div>
                <div className="d-flex justify-content-center mt-5 social-index">
                    <a href="https://www.instagram.com/ligaincom" target="_blank"><i className="fa-brands fa-instagram instagram me-5"></i></a>
                    <a href="https://x.com/ligaincom" target="_blank"><i className="fa-brands fa-x-twitter twitter ms-5"></i></a>
                </div>
            </div>


            {/* Slider */}
            {/*<div id="carouselExampleSlidesOnly" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-inner">
                    {sliders.map((item, index) => (
                        <div key={item.id} className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                            <img className="d-block w-100" src={item.img_url || 'https://via.placeholder.com/800x400'} alt={`${item.name} slide`} />
                            <div className="carousel-caption d-none d-md-block">
                                <h5>{item.name}</h5>
                                <p>{item.type === 'movies' ? 'Película' : 'Serie'}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div id="carouselExampleSlidesOnly" className="carousel slide" data-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img className="d-block w-100" src="..." alt="First slide" />
    </div>
    <div className="carousel-item">
      <img className="d-block w-100" src="..." alt="Second slide" />
    </div>
    <div className="carousel-item">
      <img className="d-block w-100" src="..." alt="Third slide" />
    </div>
  </div>
</div>*/}
       </div>
       <br />
       <div className="financing-banner">
    <p>
    <a href="https://www.investigacion.us.es/divulgacion/divulga-us" target="_blank" rel="noopener noreferrer">
        <img src={`https://grupo.us.es/ligaincom/public/uploads/images/logous.png`} width="180px" height="auto" alt="Logous" id="logo-us" />
    </a>
        Proyecto financiado por <a href="https://www.investigacion.us.es/divulgacion/divulga-us" target="_blank" rel="noopener noreferrer">
        Ayudas para Actividades de Divulgación Científica del Plan Propio de la Universidad de Sevilla
        </a>
    </p>
</div>
       </div>
    );
};

export default BdIndex;
